import './styles/page.css'
import { useEffect, useState } from "react"
import { getCookie, setCookie } from "../../config/cookies"
import dayjs from "dayjs"
import DateFiltro from "./components/DateFiltro"
import TotalRegistros from './components/TotalRegistros'
import { retornarDadosBasicos, retornarDatasDentroPeriodo, retornarLogsListaDatas } from './scripts/loadFunctions'
import { toast } from 'react-toastify'
import BarChartMethodsVolume from './components/BarChartMethodsVolume'
import PieChartApiVolume from './components/PieChartApiVolume'
import { iDadosBasicos } from './dto/DadosBasicos.dto'
import BarChartStatusVolume from './components/BarChartStatusVolume'
import TreeChartSystemVolume from './components/TreeChartSystemVolume'
import PieChartAmbienteVolume from './components/PieChartAmbienteVolume'
import BarChartVolumePorHora from './components/BarChartVolumePorHora'
import TablePesquisaRegistros from './components/TablePesquisaRegistros'

function MetricasPage() {

    // State Definition

    const [dataInicial, setDataInicial] = useState<string>(dayjs().format("YYYY-MM-DD"))
    const [dataFinal, setDataFinal] = useState<string>(dayjs().format("YYYY-MM-DD"))
    const [logsDados, setLogsDados] = useState<any[]>([])
    const [totalRegistros, setTotalRegistros] = useState<number>(0)
    const dadosBasicosInit:iDadosBasicos = {Slowest_Response: "",Fastest_Response: "",Average_Response_Time: "",Average_Payload_Size: "", Median_Reqs_Per_Hour: ""}
    const [dadosBasicos, setDadosBasicos] = useState<iDadosBasicos>(dadosBasicosInit)
    async function resetarState() {
        setLogsDados([])
        setTotalRegistros(0)
        setDadosBasicos(dadosBasicosInit)
    }

    useEffect(() => {

        const id_usuario = getCookie('id_user')
        console.log(`ID USUARIO LOGADO ${id_usuario}`)

        document.title = 'Métricas Admin | OB PORTUS'

        if (id_usuario === "") {
            let urlNow = window.location.href
            setCookie('redirect', urlNow)
            window.location.assign(`/login?redirect=${urlNow}`)
        } else {
            loadLogs(dataInicial, dataFinal)
        }
        // eslint-disable-next-line
    }, [])

    async function loadLogs(data_inicial:string, data_final:string) {

        await resetarState()

        const datas:string[] = await retornarDatasDentroPeriodo(data_inicial, data_final)
        console.log(datas)

        if (datas.length <= 0) {
            toast.warning('Verifique o período selecionado!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return
        }

        const logs:any[] = await retornarLogsListaDatas(datas)
        
        if (logs.length === 0) {
            // toast.warning('Não há dados no período selecionado!', {
            //     containerId: 1,
            //     position: 'top-center',
            //     theme: 'dark'
            // })
            return
        }

        const dadosBasicosAux = retornarDadosBasicos(logs)
        
        console.log(logs)
        setLogsDados(logs)
        setTotalRegistros(logs.length)
        setDadosBasicos(dadosBasicosAux)

    }

    // Handle Functions
    
    async function handleChangeDate(dados: any) {
        if (dados.id === "data_inicial") {
            setDataInicial(dados.value)
        }
        if (dados.id === "data_final") {
            setDataFinal(dados.value)
        }
    }
    
    async function handleRefresh() {
        // await funcSleep(500)
        await loadLogs(dataInicial, dataFinal)
    }

    async function handleArrow(proximaData:string) {
        console.log(proximaData)
        setDataInicial(proximaData)
        setDataFinal(proximaData)
        await loadLogs(proximaData, proximaData)
    }

    return (
        <div id="pageMetrics">
            <link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet" />
            <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />

            <div id='filtro_painel'>
                <DateFiltro inicial={dataInicial} final={dataFinal} handleChange={handleChangeDate} handleRefresh={handleRefresh} handleArrow={handleArrow} />
                <div className='div-row'>
                    <TotalRegistros title='Median Reqs Per Hour' totalRegistros={`${dadosBasicos.Median_Reqs_Per_Hour}`} />
                    <TotalRegistros title='Slowest Response' totalRegistros={`${dadosBasicos.Slowest_Response} ms`} />
                    <TotalRegistros title='Fastest Response' totalRegistros={`${dadosBasicos.Fastest_Response} ms`} />
                    <TotalRegistros title='Average Response Time' totalRegistros={`${dadosBasicos.Average_Response_Time} ms`} />
                    <TotalRegistros title='Average Payload Size' totalRegistros={`${dadosBasicos.Average_Payload_Size} bytes`} />
                    <TotalRegistros title='Total Requests' totalRegistros={`${totalRegistros}`} />
                </div>
            </div>

            <div className='div-row'>
                { logsDados.length > 0 && <BarChartMethodsVolume data={logsDados} /> }
                { logsDados.length > 0 && <PieChartApiVolume data={logsDados} /> }
                { logsDados.length > 0 && <PieChartAmbienteVolume data={logsDados} /> }
            </div>

            <div className='div-row'>
                { logsDados.length > 0 && <BarChartStatusVolume data={logsDados} /> }
                { logsDados.length > 0 && <TreeChartSystemVolume data={logsDados} /> }
            </div>

            <div className='div-row'>
                { logsDados.length > 0 && <BarChartVolumePorHora data={logsDados} /> }
            </div>

            <div className='div-row'>
                { logsDados.length > 0 && <TablePesquisaRegistros data={logsDados} /> }
            </div>

        </div>
    )
}

export default MetricasPage
